import { getCurrentOrgId, patchConfigInfo } from '@thoughtspot/session-service';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Admin__FeatureManagementCategory, Admin__FeatureManagementScope, useGetFeatureManagementLazyQuery, useSetFeatureManagementValueMutation, } from '../../../../services/feature-management/feature-management-service';
const mapApiToOrgFeatures = (apiData) => {
    if (!apiData?.data)
        return [];
    return apiData.data.flatMap((group) => (group.features ?? []).map((feature) => ({
        configName: feature.featureId,
        orgIds: [],
        elementType: 'toggle',
        value: feature.elementValue ?? 'false',
    })));
};
export const useOrgFeatures = ({ searchTerm, }) => {
    const currentOrgId = getCurrentOrgId();
    const [allFeatures, setAllFeatures] = useState([]);
    const { data: featureData, loading, getFeatureManagement, } = useGetFeatureManagementLazyQuery();
    const { setFeatureManagementValue, } = useSetFeatureManagementValueMutation();
    useEffect(() => {
        getFeatureManagement(currentOrgId, Admin__FeatureManagementCategory.EarlyAccess, Admin__FeatureManagementScope.Org);
    }, [getFeatureManagement]);
    useEffect(() => {
        setAllFeatures(mapApiToOrgFeatures(featureData));
    }, [featureData]);
    const features = useMemo(() => {
        if (!searchTerm)
            return allFeatures;
        const query = searchTerm.trim().toLowerCase();
        return allFeatures.filter(f => f.configName.toLowerCase().includes(query));
    }, [allFeatures, searchTerm]);
    const updateFeatureValue = useCallback((configName, newValue) => {
        const previousFeatures = allFeatures;
        setAllFeatures(prev => prev.map(f => f.configName === configName ? { ...f, value: newValue } : f));
        setFeatureManagementValue({
            scope: Admin__FeatureManagementScope.Org,
            org_identifier: currentOrgId,
            feature_identifier: configName,
            feature_value: newValue,
        }, () => {
            patchConfigInfo(configName, newValue);
        }, () => {
            setAllFeatures(previousFeatures);
        });
    }, [allFeatures, currentOrgId, setFeatureManagementValue]);
    return {
        features,
        initialLoading: loading,
        contentLoading: false,
        updateFeatureValue,
    };
};
//# sourceMappingURL=use-org-features.js.map